import { render } from "./MathsTestResult.vue?vue&type=template&id=7e65f2d8&ts=true"
import script from "./MathsTestResult.vue?vue&type=script&lang=ts"
export * from "./MathsTestResult.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__